import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"

import DFPAdManager from "../ui/DFPAdManager/DFPAdManager"
import { QuizSEO } from "../ui/QuizSEO"
import Comscore from "../ui/Comscore"
import Header from "../ui/Header/Header"
import ColorTheme from "../ui/ColorTheme/ColorTheme"
import Container from "../ui/Container/Container"
import QuizIntro from "../ui/QuizIntro/QuizIntro"
import QuizCarousel from "../ui/QuizCarousel/QuizCarousel"
import Footer from "../ui/Footer/Footer"
import { getResult } from "../utils/getResult"
import { useQuizData } from "../utils/querys/useQuizData"

import FSLogo from "../images/fansided-logo.svg"

import "../styles/index.module.scss"

const QuizTemplate = ({ location }) => {
    const [usersAnswersList, setUsersAnswersList] = useState({})
    const [submit, setSubmit] = useState(false)
    const [startQuiz, setStartQuiz] = useState(false)
    const [slideIndex, setSlideIndex] = useState(0)
    const [resultList, setResultList] = useState([])

    const data = useQuizData()
    const {
        meta: {
            nodes: [meta],
        },
    } = data
    const answerLength = Object.keys(usersAnswersList).length
    const quizLength = Object.keys(data.questions.nodes).length
    const adLength = data.questions.nodes.filter(
        question => question.questions.question === "ad"
    ).length

    useEffect(() => {
        if (answerLength === quizLength - adLength) {
            setSubmit(s => !s)
        }
    }, [answerLength, quizLength, adLength])

    useEffect(() => {
        if (submit) {
            setResultList(getResult(data, usersAnswersList).splice(0, 5))
        }
    }, [submit])

    useEffect(() => {
        setStartQuiz(location.state?.startQuizFromResults)
        setSubmit(location.state?.submitFromResults)
    }, [location])

    useEffect(() => {
        if (typeof window == "object") {
            window.localStorage.setItem(
                "result_list",
                JSON.stringify(resultList)
            )
            window.localStorage.setItem("result_index", 0)
        }
    }, [resultList])

    const handleClick = (ans, quesId, index) => {
        if (ans) {
            setUsersAnswersList({ ...usersAnswersList, [quesId]: ans })
        }
        setSlideIndex(index + 1)
    }

    const handleStartQuiz = () => {
        setStartQuiz(s => !s)
        setSlideIndex(0)
    }

    return (
        <Container>
            <DFPAdManager />
            <Comscore />
            <QuizSEO meta={meta.meta} />
            <ColorTheme
                lighterColor={meta.meta.styles.lighterColor}
                darkerColor={meta.meta.styles.darkerColor}
            />
            {!startQuiz && (
                <QuizIntro
                    data={meta.meta}
                    fansidedLogo={FSLogo}
                    quizLength={quizLength}
                    onClick={handleStartQuiz}
                />
            )}
            {!submit && startQuiz && (
                <>
                    <Header
                        siteTitle={meta.meta.name}
                        border
                        shareText={meta.meta.shareText}
                        shareUrl={location.href}
                        navigateToStart={handleStartQuiz}
                    />
                    <QuizCarousel
                        data={data.questions.nodes}
                        handleClick={handleClick}
                        slideIndex={slideIndex}
                        setSlideIndex={setSlideIndex}
                        reTakeIndex={location?.state?.reTakeIndex}
                    />
                    <Footer height="4rem" />
                </>
            )}
            {resultList.length >= 1 && (
                <>
                    {navigate(resultList[0].fields.result_slug, {
                        state: {
                            resultList: resultList,
                            reTakeIndex: location?.state?.reTakeIndex,
                        },
                    })}
                </>
            )}
        </Container>
    )
}

QuizTemplate.defaultProps = {
    state: null,
}

QuizTemplate.propTypes = {
    location: PropTypes.shape({
        href: PropTypes.string.isRequired,
        state: PropTypes.shape({
            key: PropTypes.string,
            reTakeIndex: PropTypes.string,
            startQuizFromResults: PropTypes.bool,
            submitFromResults: PropTypes.bool,
        }),
    }),
}

export default QuizTemplate
